export const DESKTOP_MIN_RANGE = 1024;
export const DESKTOP_MAX_RANGE = 2147483647;
export const DESKTOP_CANVAS_SIZE = 1280;
export const MOBILE_MIN_RANGE = 0;
export const MOBILE_MAX_RANGE = 1023;
export const MOBILE_CANVAS_SIZE = 390;
